<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  mode: {
    type: String,
    default: 'add',
  },
});

const emit = defineEmits(['submit']);

const { t } = useI18n();
const lists = useMapGetter('contactLists/getLists');
const selectedIds = ref([]);

const options = computed(() => lists.value || []);

const toggle = id => {
  selectedIds.value = selectedIds.value.includes(id)
    ? selectedIds.value.filter(item => item !== id)
    : [...selectedIds.value, id];
};

const submit = () => {
  if (!selectedIds.value.length) return;
  emit('submit', selectedIds.value);
  selectedIds.value = [];
};
</script>

<template>
  <div
    class="absolute z-20 flex flex-col w-64 p-3 border rounded-xl shadow-lg bg-n-solid-2 border-n-weak top-8 ltr:right-0 rtl:left-0"
  >
    <p class="mb-2 text-sm font-medium text-n-slate-12">
      {{
        mode === 'move'
          ? t('CONTACTS_BULK_ACTIONS.LISTS.MOVE_TITLE')
          : t('CONTACTS_BULK_ACTIONS.LISTS.ADD_TITLE')
      }}
    </p>
    <div v-if="!options.length" class="text-sm text-n-slate-11">
      {{ t('CONTACTS_BULK_ACTIONS.LISTS.EMPTY') }}
    </div>
    <div v-else class="flex flex-col gap-1 overflow-y-auto max-h-48">
      <label
        v-for="list in options"
        :key="list.id"
        class="flex items-center gap-2 text-sm text-n-slate-12"
      >
        <input
          type="checkbox"
          class="rounded border-n-weak"
          :checked="selectedIds.includes(list.id)"
          @change="toggle(list.id)"
        />
        <span class="truncate">{{ list.name }}</span>
      </label>
    </div>
    <Button
      class="mt-3"
      sm
      :label="t('CONTACTS_BULK_ACTIONS.LISTS.CONFIRM')"
      :disabled="!selectedIds.length"
      @click="submit"
    />
  </div>
</template>
